import React from "react";
import { Modal, Button } from "react-bootstrap";

function ConfirmDeleteModal({
  show = false,
  title = "Are you sure?",
  message = "This action cannot be undone. This will permanently delete this family member.",
  onConfirm,
  onCancel,
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Body className="px-3 py-4 text-center">
        <Modal.Title className="text-center mb-2">{title}</Modal.Title>
        <div className="my-3 px-3">{message}</div>
        <Modal.Footer className="border-top-0 d-flex align-items-center justify-content-center gap-2">
          <Button
            className="btn-light-md"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelText}
          </Button>

          <Button
            className="btn-orange-md"
            style={{ backgroundColor: "#eda92b", borderColor: "#eda92b" }}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : confirmText}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmDeleteModal;
